import { useEffect, useState } from 'react';
import { Button, Input, Modal } from '../ui';

interface PaymentDateModalProps {
  isOpen: boolean;
  initialDate: string;
  title: string;
  confirmLabel: string;
  isPending?: boolean;
  onClose: () => void;
  onConfirm: (paymentDate: string) => void | Promise<void>;
}

export function PaymentDateModal({
  isOpen,
  initialDate,
  title,
  confirmLabel,
  isPending = false,
  onClose,
  onConfirm,
}: PaymentDateModalProps) {
  const [paymentDate, setPaymentDate] = useState(initialDate);

  useEffect(() => {
    if (isOpen) setPaymentDate(initialDate);
  }, [initialDate, isOpen]);

  const handleConfirm = async () => {
    if (!paymentDate) return;
    await onConfirm(paymentDate);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <div className="space-y-5">
        <Input
          label="Bezahlt am"
          type="date"
          value={paymentDate}
          onChange={(event) => setPaymentDate(event.target.value)}
          required
          autoFocus
        />
        <div className="flex justify-end gap-2">
          <Button variant="secondary" onClick={onClose} disabled={isPending}>
            Abbrechen
          </Button>
          <Button
            onClick={handleConfirm}
            loading={isPending}
            disabled={!paymentDate}
            className="bg-green-600 hover:bg-green-700"
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
